import { getGuarantorDesc, getNumberFormat } from "../../utils/enums";

export const GuarantorListColumns = () => {
  return [
    { field: "id", headerName: "ID", width: 90, hide: true },
    {
      field: "collateral",
      headerName: "Teminat",
      sortable: false,
      flex:1,
      align: "left",
      headerAlign: "center",
      valueGetter: (params) => {
        return params.value  //getGuarantorDesc(params.value);
      },
    },
    {
      field: "amount",
      headerName: "Tutar",
      sortable: false,
      width:200,
      align: "right",
      headerAlign: "center",
      valueGetter: (params) => {
        return getNumberFormat(params.value);
      },
    },
  ];
};
